export default (host: string) => ({
  '@id': 'organization',
  'address': {
    '@type': 'PostalAddress',
    'addressCountry': 'CH',
    'addressLocality': 'Stabio',
    'addressRegion': 'Ticino',
    'postalCode': '6855',
    'streetAddress': 'Via Laveggio 5'
  },
  'areaServed': 'NL',
  'brand': {
    '@type': 'Brand',
    '@id': `https://${host}/nl-nl#brand`,
    'name': 'Timberland',
    'description': 'Timberland is Built for the Bold. We inspireren avonturiers met een goede uitrusting om eropuit te gaan, hard te werken en de wereld vooruit te helpen.',
    'url': `https://${host}/nl-nl`,
    'image': `https://${host}/img/logo50.svg`
  },
  'contactPoint': [
    {
      '@type': 'ContactPoint',
      'telephone': '0800.323.2010',
      'contactType': 'Telephone',
      'areaServed': 'NL',
      'hoursAvailable': 'Mo,Tu,We,Th,Fr 09:00-19:00 CEST'
    },
    {
      '@type': 'ContactPoint',
      'contactType': 'Chat',
      'areaServed': 'NL',
      'hoursAvailable': 'Mo,Tu,We,Th,Fr 09:00-19:00 CEST',
      'url': `https://${host}/nl-nl`
    }
  ],
  'logo': {
    '@id': '#logo',
    'caption': 'Timberland',
    'contentUrl': `https://${host}/img/logo50.svg`,
    'url': `https://${host}/img/logo50.svg`
  },
  'name': 'Timberland',
  'parentOrganization': 'VF Corporation (VFC)',
  'sameAs': [
    'https://www.youtube.com/timberland',
    'https://www.instagram.com/timberland',
    'https://www.facebook.com/timberland'
  ],
  'url': `https://${host}/nl-nl`
})
